import styled, { keyframes } from "styled-components";
import {
  REGISTRATION_FONT_BODY,
  REGISTRATION_FONT_DISPLAY,
  REGISTRATION_FOREST,
  REGISTRATION_LINK,
} from "../../../RegistrationLayout/registrationTheme";
import { registrationFormStyles } from "../../../RegistrationLayout/registrationFormStyles";
import { registrationReducedMotionStyles } from "../../../RegistrationLayout/registrationMotionStyles";

const popIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.96);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: rgba(8, 15, 28, 0.5);
`;

export const ModalPanel = styled.div`
  ${registrationReducedMotionStyles}
  background: #ffffff;
  border-radius: 16px;
  max-width: 520px;
  width: 100%;
  max-height: 85vh;
  overflow-y: auto;
  box-shadow: 0 24px 60px rgba(8, 15, 28, 0.2);
  animation: ${popIn} 0.2s ease;
  font-family: ${REGISTRATION_FONT_BODY};
  ${registrationFormStyles}

  .btn-primary,
  .btn-ghost {
    width: auto;
    margin-top: 0;
    padding: 8px 14px;
    font-size: 12px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 22px 24px 16px;
  border-bottom: 1px solid rgba(30, 42, 53, 0.08);
  position: sticky;
  top: 0;
  background: #ffffff;
  border-radius: 16px 16px 0 0;
  z-index: 1;
`;

export const ModalTitle = styled.h3`
  font-family: ${REGISTRATION_FONT_DISPLAY};
  font-size: 20px;
  font-weight: 500;
  color: #2d3f52;
  margin: 0 0 4px;
`;

export const ModalSubtitle = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${REGISTRATION_FOREST};
  line-height: 1.5;
`;

export const ModalCloseBtn = styled.button`
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: ${REGISTRATION_FOREST};
  line-height: 1;
  padding: 4px;
  flex-shrink: 0;
  font-family: ${REGISTRATION_FONT_BODY};
`;

export const ModalBody = styled.div`
  padding: 20px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const RdOptionCard = styled.div`
  border: 1px solid rgba(30, 42, 53, 0.1);
  border-radius: 12px;
  padding: 16px;
  display: flex;
  gap: 14px;
  align-items: flex-start;
`;

export const RdAvatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  flex-shrink: 0;
  font-family: ${REGISTRATION_FONT_BODY};
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
`;

export const RdInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const RdName = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: #2d3f52;
  margin-bottom: 4px;
`;

export const RdCreds = styled.div`
  font-size: 12px;
  color: ${REGISTRATION_FOREST};
  margin-bottom: 8px;
`;

export const RdTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-bottom: 12px;
`;

export const RdTag = styled.span`
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 999px;
  background: rgba(174, 206, 56, 0.12);
  color: ${REGISTRATION_LINK};
  font-weight: 600;
`;

export const RdActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const EmptyMessage = styled.p`
  margin: 0;
  font-size: 13px;
  color: ${REGISTRATION_FOREST};
  line-height: 1.6;
`;
